import { defineMessages } from 'react-intl';

export default defineMessages({
  AccessCommanderConnectingModalTitle: {
    defaultMessage: 'Open Access Commander',
    id: 'accessCommanderConnecting.modal.title',
  },
});
